export default __webpack_public_path__ + "static/media/logo17.f2beea1f.png";